export const customersData = [
  {
    key: "1",
    CUSTOMER_IMG: "customer-11.jpg",
    CUSTOMER: "Andrew Simons",
    PHONE: "+1 56598 98956",
    EMAIL: "andrewsimons@example.com",
    FLAG_IMG: "gb.svg",
    LANGUAGE: "English",
    DOCUMENTS: "Show Documents",
    RENTS: "Recent Rents",
  },
  {
    key: "2",
    CUSTOMER_IMG: "customer-12.jpg",
    CUSTOMER: "David Steiger",
    PHONE: "+1 24558 56599",
    EMAIL: "davidsteiger@example.com",
    FLAG_IMG: "it-flag.svg",
    LANGUAGE: "Italian",
    DOCUMENTS: "Show Documents",
    RENTS: "Recent Rents",
  },
  {
    key: "3",
    CUSTOMER_IMG: "customer-13.jpg",
    CUSTOMER: "Darin Mabry",
    PHONE: "+1 24558 56599",
    EMAIL: "darinmabry@example.com",
    FLAG_IMG: "fr-flag.svg",
    LANGUAGE: "French",
    DOCUMENTS: "No Documents",
    RENTS: "",
  },
  {
    key: "4",
    CUSTOMER_IMG: "customer-14.jpg",
    CUSTOMER: "Mark Neiman",
    PHONE: "+1 56598 98956",
    EMAIL: "markneiman@example.com",
    FLAG_IMG: "gb.svg",
    LANGUAGE: "English",
    DOCUMENTS: "Show Documents",
    RENTS: "Recent Rents",
  },
  {
    key: "5",
    CUSTOMER_IMG: "customer-15.jpg",
    CUSTOMER: "Jacob Johnson",
    PHONE: "+1 56598 98956",
    EMAIL: "jacobjohnson@example.com",
    FLAG_IMG: "fr-flag.svg",
    LANGUAGE: "German",
    DOCUMENTS: "No Documents",
    RENTS: "",
  },
  {
    key: "6",
    CUSTOMER_IMG: "customer-16.jpg",
    CUSTOMER: "Walter Hartmann",
    PHONE: "+1 24558 56599",
    EMAIL: "walterhartmann@example.com",
    FLAG_IMG: "it-flag.svg",
    LANGUAGE: "Italian",
    DOCUMENTS: "Show Documents",
    RENTS: "Recent Rents",
  },
  {
    key: "7",
    CUSTOMER_IMG: "customer-17.jpg",
    CUSTOMER: "Andrea Jermaine",
    PHONE: "+1 12488 14457",
    EMAIL: "andreajermaine@example.com",
    FLAG_IMG: "gb.svg",
    LANGUAGE: "English",
    DOCUMENTS: "No Documents",
    RENTS: "",
  },
  {
    key: "8",
    CUSTOMER_IMG: "customer-18.jpg",
    CUSTOMER: "Dennis Eckhardt",
    PHONE: "+1 32569 15458",
    EMAIL: "denniseckhardt@example.com",
    FLAG_IMG: "it-flag.svg",
    LANGUAGE: "Italian",
    DOCUMENTS: "Show Documents",
    RENTS: "Recent Rents",
  },
  {
    key: "9",
    CUSTOMER_IMG: "customer-19.jpg",
    CUSTOMER: "Lan Adams",
    PHONE: "+1 14782 14578",
    EMAIL: "lanadams@example.com",
    FLAG_IMG: "fr-flag.svg",
    LANGUAGE: "French",
    DOCUMENTS: "No Documents",
    RENTS: "",
  },
  {
    key: "10",
    CUSTOMER_IMG: "customer-20.jpg",
    CUSTOMER: "Julie Black",
    PHONE: "+1 12124 14255",
    EMAIL: "julieblack@example.com",
    FLAG_IMG: "gb.svg",
    LANGUAGE: "English",
    DOCUMENTS: "Show Documents",
    RENTS: "Recent Rents",
  },
];
